import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../../../shared/components/Alert";
import DefaultButton from "../../../shared/components/DefaultButton";
import { instance } from "../../../shared/utilites/ApiClient";

const RequestPasswordReset = () => {
  const markPath = "/mark-dark.png";

  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMessage] = useState("");

  const validate = (values) => {
    let errors = {};
    if (!values.employee_id) {
      errors.employee_id = "Enter your employee id";
    }
    return errors;
  };

  const submit = (values) => {
    instance.post("/login/requestPasswordReset", { user_id: values.employee_id }).then(() => {
      setSubmitted(true);
    }).catch(e => {
      setErrorMessage(e?.response?.data?.msg);
    });
  };

  return (
    <div className="login-page login-page--light">
      <div className="login-shell login-shell--single">
        <div className="login-page login-page--light login-page--reset">
        <div className="login-card">
          <div className="login-brand">
            <img src={markPath} alt="" aria-hidden="true" className="login-logo" />
            <h1>Reset Password</h1>
            {/* <p>Enter your user ID and we'll email you a reset link</p> */}
          </div>

          {errorMsg && (
            <Alert key="danger" alertType="alert alert-dismissible fade show alert-danger" message={errorMsg} />
          )}

          {submitted ? (
            <div className="login-success">
              Request submitted. Please check the email associated with the account.
            </div>
          ) : (
            <Formik
              validate={validate}
              initialValues={{ employee_id: "" }}
              onSubmit={submit}
            >
              {({ errors, touched }) => (
                <Form>
                  <div className="login-field">
                    <label htmlFor="employee_id">User ID</label>
                    <div className="login-input-wrap">
                      <svg className="login-input-icon" viewBox="0 0 24 24">
                        <circle cx="12" cy="8" r="4" />
                        <path d="M4 20c1.5-4 4.5-6 8-6s6.5 2 8 6" />
                      </svg>
                      <Field
                        id="employee_id"
                        name="employee_id"
                        placeholder="Enter your user ID"
                        autoComplete="off"
                        autoFocus
                        className={`login-input ${touched.employee_id && errors.employee_id ? "is-invalid" : ""}`}
                      />
                    </div>
                    <ErrorMessage name="employee_id" component="div" className="login-error" />
                  </div>

                  <DefaultButton
                    buttonTitle="Reset"
                    buttonClass="default-btn-color login-btn"
                    buttonType="submit"
                  />
                </Form>
              )}
            </Formik>
          )}

          <Link to="/login" className="login-back">← Return to Login</Link>
        </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;